import { rankingItems } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新四虎影视大全最受欢迎电视剧排名
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 rounded-xl transition-all duration-200 group ${
                idx === 0
                  ? 'bg-gradient-to-r from-primary-500/10 to-accent-500/5 border border-primary-500/20'
                  : 'hover:bg-background-200/30 border border-transparent hover:border-background-300/30'
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-primary-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.type}</span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}热度</span>
                {item.change === 'up' && <i className="ri-arrow-up-fill text-accent-400"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-fill text-foreground-500"></i>}
                {item.change === 'new' && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-500 text-white whitespace-nowrap">NEW</span>}
                {item.change === 'stable' && <i className="ri-subtract-line text-foreground-500"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}